<template>
  <div
    class="c-badge"
    :style="variantStyles"
  >
    <img
      v-if="imageUrl"
      class="c-badge__image"
      :src="imageUrl"
      :alt="altText || 'Badge'"
    >
    <div
      v-else
      class="c-badge__slot"
      :class="backgroundClass"
      :style="slotStyles"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    altText: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'white'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    backgroundClass: {
      type:String,
      default: ''
    }
  },
  computed: {
    slotStyles () {
      const backgroundColor = this.backgroundColor
      const backgroundClass = this.backgroundClass
      let result = {}
      if (backgroundColor && !backgroundClass) {
        result['background-color'] = backgroundColor
      }
      return result
    },
    variantStyles () {
      const imageUrl = this.imageUrl
      const color = this.color
      const backgroundColor = this.backgroundColor
      let result = {}
      if (color) {
        result['color'] = color
      }
      if (backgroundColor && imageUrl) {
        result['background-color'] = backgroundColor
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-badge {
  position: absolute;
  z-index: $zindex-tooltip + 1;

  &__image {
    padding: rem(10px);
    max-width: 100%;
  }
  &__slot {
    text-transform: uppercase;
    height: rem(28px);
    padding-left: rem(12px);
    padding-right: rem(12px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__align-top-left {
    top: 0;
    left: 0;

    .c-badge__slot {
      margin-top: rem(38px);
    }
  }
  &__align-top-right {
    top: 0;
    right: 0;

    .c-badge__slot {
      margin-top: rem(38px);
    }
  }
  &__align-bottom-left {
    bottom: 0;
    left: 0;

    .c-badge__slot {
      margin-bottom: rem(38px);
    }
  }
  &__align-bottom-right {
    bottom: 0;
    right: 0;

    .c-badge__slot {
      margin-bottom: rem(38px);
    }
  }
}
</style>
